import type { JSX, SVGProps } from 'react';
export default function SvgRecordCircle2(props: SVGProps<SVGSVGElement>): JSX.Element {
    // ----------------------------------------------------------------------------------------------------
    // MARK: Main Component UI
    // ----------------------------------------------------------------------------------------------------
    return (
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor" {...props}>
            <path d="M11.9697 2C6.44973 2 1.96973 6.48 1.96973 12C1.96973 17.52 6.44973 22 11.9697 22C17.4897 22 21.9697 17.52 21.9697 12C21.9697 6.48 17.4997 2 11.9697 2ZM11.9997 16.23C9.65973 16.23 7.76973 14.34 7.76973 12C7.76973 9.66 9.65973 7.77 11.9997 7.77C14.3397 7.77 16.2297 9.66 16.2297 12C16.2297 14.34 14.3397 16.23 11.9997 16.23Z" />
        </svg>
    );
}
